module.exports = {
  COUPONS_CLICK_STORE_PAGE_COUPON: 'coupons-click-store-page-coupon',
  COUPONS_CLICK_ALL: 'coupons-click-all',
  COUPONS_CLICK_TOUCH_ALL: 'coupons-click-touch-all',
  COUPONS_CLICK_TOUCH_HOMEPAGE_TOP_STORE_OR_CATEGORY: 'coupons-click-touch-homepage-top-store-or-category'
};

